export const headList = [
    { code: "competitionName", title: "League Name", mobileHide: false, isNumeric: false },
    { code: "picksetName", title: "Pickset Name", mobileHide: false, isNumeric: false },
    { code: "creatorName", title: "Commissioner", mobileHide: false, isNumeric: false },
    { code: "competitionTools", title: "Tools", mobileHide: false, isNumeric: false }

];